import { render, staticRenderFns } from "./gtrans.vue?vue&type=template&id=32ecd296&scoped=true&"
import script from "./gtrans.vue?vue&type=script&lang=js&"
export * from "./gtrans.vue?vue&type=script&lang=js&"
import style0 from "./gtrans.vue?vue&type=style&index=0&id=32ecd296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ecd296",
  null
  
)

export default component.exports